import { useCallback, useRef } from 'react';

const useDynaMXFormFieldRegistry = () => {
  const fieldsRef = useRef(new Map());

  const registerDynaMXField = useCallback((field) => {
    const { sitecoreFormModelName, inputElement } = field || {};

    if (!sitecoreFormModelName || !inputElement) {
      return () => {};
    }

    fieldsRef.current.set(sitecoreFormModelName, field);

    return () => {
      const currentField = fieldsRef.current.get(sitecoreFormModelName);
      if (currentField && currentField.inputElement === inputElement) {
        fieldsRef.current.delete(sitecoreFormModelName);
      }
    };
  }, []);

  const getDynaMXField = useCallback((sitecoreFormModelName) => {
    if (!sitecoreFormModelName) return null;
    return fieldsRef.current.get(sitecoreFormModelName) || null;
  }, []);

  const getDynaMXFields = useCallback(
    () => Array.from(fieldsRef.current.values()),
    [],
  );

  return {
    registerDynaMXField,
    getDynaMXField,
    getDynaMXFields,
  };
};

export default useDynaMXFormFieldRegistry;
